module.exports = __webpack_public_path__ + "media/entities/5204-666d54b0.png";